// 주간보고 ↔ 장비 이슈 딥링크 공용 타입/유틸

// 주간보고에 연결된 장비 이슈 (표시용 캐시 포함)
export interface LinkedIssue {
  equipmentId: string
  issueId: string
  equipmentName?: string
  issueTitle?: string
  unitLabel?: string
}

// 장비이력 화면으로 이슈 딥링크 진입 시 전달되는 타깃
export interface IssueLinkTarget {
  equipmentId: string
  issueId: string
}

// 세션 기반 딥링크 전달 (App 상태와 별개로 새로고침에도 잠깐 유지)
const STORAGE_KEY = "pendingIssueTarget"

export function setPendingIssueTarget(target: IssueLinkTarget): void {
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(target))
  } catch (e) {
    console.warn("Failed to persist issue target:", e)
  }
}

export function consumePendingIssueTarget(): IssueLinkTarget | null {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY)
    if (!raw) return null
    sessionStorage.removeItem(STORAGE_KEY)
    return JSON.parse(raw) as IssueLinkTarget
  } catch (e) {
    console.warn("Failed to read issue target:", e)
    return null
  }
}

// 이메일 등 앱 외부에서 특정 이슈로 진입시키기 위한 딥링크 URL 생성
// 예: https://preview--6nw85q.lumi.ing/?page=equipmentHistory&equipmentId=...&issueId=...
export function buildIssueDeepLinkUrl(target: IssueLinkTarget): string {
  try {
    const origin =
      typeof window !== "undefined" && window.location?.origin
        ? window.location.origin
        : ""
    const params = new URLSearchParams({
      page: "equipmentHistory",
      equipmentId: target.equipmentId,
      issueId: target.issueId,
    })
    return `${origin}/?${params.toString()}`
  } catch (e) {
    console.warn("Failed to build deep link url:", e)
    return ""
  }
}

// 앱 진입 시 URL 쿼리에서 이슈 딥링크 타깃을 파싱 (없으면 null)
export function parseIssueTargetFromUrl(): IssueLinkTarget | null {
  try {
    if (typeof window === "undefined") return null
    const params = new URLSearchParams(window.location.search)
    if (params.get("page") !== "equipmentHistory") return null
    const equipmentId = params.get("equipmentId") || ""
    const issueId = params.get("issueId") || ""
    if (!equipmentId || !issueId) return null
    return { equipmentId, issueId }
  } catch (e) {
    console.warn("Failed to parse issue target from url:", e)
    return null
  }
}

// 딥링크 처리 후 URL 쿼리를 정리 (새로고침 시 중복 진입 방지)
export function clearIssueTargetFromUrl(): void {
  try {
    if (typeof window === "undefined") return
    const url = new URL(window.location.href)
    url.searchParams.delete("page")
    url.searchParams.delete("equipmentId")
    url.searchParams.delete("issueId")
    window.history.replaceState({}, "", url.pathname + url.search + url.hash)
  } catch (e) {
    console.warn("Failed to clear issue target from url:", e)
  }
}
